import React from 'react';

import classNames from 'classnames';

import classes from './DetailsTable.module.scss';
import { getPriceView } from '../../../../shared/utils/stringUtils';
import {
  CONSULTATION_TYPE,
  ConsultationType,
} from '../../../../shared/constants/coach/consultationType';
import { TAX_RATE_TYPE } from '../../../constants/tax';
import { TaxRateInfo } from '../../../interfaces/tax';
import { CoachInfo } from '../../../interfaces/checkoutInfo';

type DetailsTableProps = {
  //Name of subscription or challenge
  targetName: string;
  totalAmount: number;
  taxAmount: number;
  price: number;
  tax: TaxRateInfo;
  businessName?: string;
  coach?: CoachInfo;
  consultationType?: ConsultationType;
};

const DetailsTable = ({
  targetName,
  businessName,
  coach,
  tax,
  taxAmount,
  price,
  totalAmount,
  consultationType,
}: DetailsTableProps) => {
  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <div>
          <p>{targetName}</p>
          {!!coach && (
            <dl className={classes.nestedInfo}>
              <dt>Coach</dt>
              <dd>
                {coach.firstName} {coach.lastName}
              </dd>
              {businessName && (
                <>
                  <dt>Business Name</dt>
                  <dd>{businessName}</dd>
                </>
              )}
              {consultationType === CONSULTATION_TYPE.REMOTE && (
                <>
                  <dt>Collaboration</dt>
                  <dd>To work with a coach remotely</dd>
                </>
              )}
            </dl>
          )}
        </div>
        <p>{getPriceView(price)}</p>
      </div>
      {tax && tax.taxRateType !== TAX_RATE_TYPE.APPLICATION_TAX_RATE && (
        <div className={classes.row}>
          <p>Tax, {tax.taxRatePercent}%</p>
          <p>{getPriceView(taxAmount)}</p>
        </div>
      )}
      <div className={classNames(classes.row, classes.totalRow)}>
        <p>Total</p>
        <p>{getPriceView(totalAmount)}</p>
      </div>
    </div>
  );
};

export { DetailsTable };
